var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aiaibot-html-widget"},[(!_vm.hideHeader)?_c('AiaiBotMessageHeader',{attrs:{"date":_vm.date,"is-outgoing":_vm.isOutgoing,"customer-name":_vm.customerName,"agent-name":_vm.agentName}}):_vm._e(),_c('div',{class:[
      'aiaibot-content tw-p-4',
      _vm.isOutgoing
        ? 'tw-rounded-t-lg tw-rounded-l-lg tw-bg-green-light-25'
        : 'tw-rounded-t-lg tw-rounded-r-lg tw-bg-white'
    ],domProps:{"innerHTML":_vm._s(_vm.localMessage)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }